import { Alert, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

/** Shown when the signed-in user has no AI assistant credits left (puzzle chat UI). */
const AssistantCreditsEmptyBar = ({
    message,
    linkLabel,
    plansPath = "/subscription/plans",
}) => (
    <Alert severity="warning" sx={{ borderRadius: 2, alignItems: "flex-start" }}>
        <Typography variant="body2" sx={{ mb: 0.75 }}>
            {message}
        </Typography>
        <Link component={RouterLink} to={plansPath} underline="hover" sx={{ fontWeight: 600 }}>
            {linkLabel}
        </Link>
    </Alert>
);

export default AssistantCreditsEmptyBar;
